import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_16DBlack_16CBlack = () => <CrossRoad coords="2403.000000, 589.000000" color={tracksColors.black}/>;

export default CrossRoad_16DBlack_16CBlack;
